import { useNavigate } from "react-router-dom";
import { isNativeUser } from "../../../utils/common";
import { useLocation } from "react-router-dom";

import { 
    PaymentContainer, 
    StatusBox, 
    SuccessIconContainer,
    SuccessTitle, 
    Message, 
    SuccessButton 
} from "../../styles/PaymentStatusStyle"

const SuccessPage = () => {
    const navigate = useNavigate();
    const isNative = isNativeUser();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const planType = queryParams.get("planType"); 

    const handleDoneClick = () => {
        let obj = {
            paymentSuccess: true,
            isCancelled: false
        }
        if (isNative) {
            if (window.webkit?.messageHandlers?.ReadRivalsJS) {
                try {
                    window.webkit?.messageHandlers?.ReadRivalsJS.paymentSuccess?.postMessage(JSON.stringify(obj));
                } catch (error) {
                    console.log(`Error sending ios javascript callback: ${error}`);
                }
            } else if (window.ReadRivalsJS !== undefined) {
                window.ReadRivalsJS?.paymentSuccess(JSON.stringify(obj));
            }
            sessionStorage.removeItem("userOS");
        } else {
            navigate("/subscription");
        }
    };

    return (
        <PaymentContainer>
        <StatusBox>
            <SuccessIconContainer>✔</SuccessIconContainer>
            <SuccessTitle>Thank You!</SuccessTitle>
            <Message>Your payment has been received</Message>
            <Message>Your plan has been upgraded to {planType}</Message>
            <SuccessButton onClick={handleDoneClick}>DONE</SuccessButton>
        </StatusBox>
    </PaymentContainer>
    );
};

export default SuccessPage;